<template>
  <div id="h5">
      <mycarousel></mycarousel>
      <div class="h51 titleBox">
        <p class="title">专业H5应用开发，让您省心省力</p>
        <ul>
            <li v-for="(item,index) in h51" :key="index"  class="wow animate__animated animate__fadeInUp">
                <img :src="item.icon" alt="">
                <p v-html="item.title"></p>
            </li>
        </ul>
      </div>
      <div class="h52">
        <img src="@/assets/h5/h52img.png" alt="" class="bg">
        <div>
            <p class="title">服务进度透明，客户权益保障</p>
            <ul>
                <li class="wow animate__animated animate__fadeInLeft">
                    <img src="@/assets/h5/piont.png" alt="">
                    <span>严谨的项目流程，专业的设计团队</span>
                </li>
                <li class="wow animate__animated animate__fadeInLeft">
                    <img src="@/assets/h5/piont.png" alt="">
                    <span>全面了解您的需求，项目顾问全程跟进</span>
                </li>
                <li class="wow animate__animated animate__fadeInLeft">
                    <img src="@/assets/h5/piont.png" alt="">
                    <span>阶段化交付成果，服务质量有保障</span>
                </li>
            </ul>
            <button>免费试用</button>
        </div>
      </div>
      <div class="h53">
        <ul class="h53Box">
            <li class="left wow animate__animated animate__fadeInLeft">
                <p class="title">说出您的需求，定制您的方案</p>
                <ul>
                    <li>
                        <img src="@/assets/h5/piont.png" alt="">
                        <span>场景定制：确定主题风格、色调内容</span>
                    </li>
                    <li>
                        <img src="@/assets/h5/piont.png" alt="">
                        <span>元素设计：结合企业文化，进行精细化设计</span>
                    </li>
                    <li>
                        <img src="@/assets/h5/piont.png" alt="">
                        <span>动效设置：静态元素以动态呈现</span>
                    </li>
                </ul>
                <button>免费试用</button>
            </li>
            <li class="right wow animate__animated animate__fadeInRight">
                <img src="@/assets/h5/h53img.png" alt="">
            </li>
        </ul>
        <div class="h53">
            <ul class="h53Box">
                <li class="right wow animate__animated animate__fadeInLeft">
                    <img src="@/assets/h5/h54img.png" alt="">
                </li>
                <li class="left wow animate__animated animate__fadeInRight">
                    <p class="title">适用上百个行业，服务10万+公司</p>
                    <ul>
                        <li>
                            <img src="@/assets/h5/piont.png" alt="">
                            <span>全生命周期营销，挖掘用户价值</span>
                        </li>
                        <li>
                            <img src="@/assets/h5/piont.png" alt="">
                            <span>多种分销裂变玩法，实现用户持续增长</span>
                        </li>
                        <li>
                            <img src="@/assets/h5/piont.png" alt="">
                            <span>全方位拉高用户单价，提升转化率</span>
                        </li>
                    </ul>
                    <button>免费试用</button>
                </li>
            </ul>
        </div>
        <div class="h54 titleBox">
            <p class="title">设计+搭建+售后一条龙高质量服务</p>
            <p class="subtitle">十年开发定制服务经验，更专业，更优质</p>
            <ul>
                <li v-for="(item,index) in h54" :key="index" class="wow animate__animated animate__fadeInUp">
                    <img :src="item.icon" alt="" class="bg">
                    <div>
                        <p>{{item.title}}</p>
                        <img src="@/assets/h5/go.png" alt="">
                    </div>
                </li>
            </ul>
        </div>
      </div>
      <mytechnology></mytechnology>
  </div>
</template>

<script>
import mycarousel from  '@/components/carousel/carousel.vue'
import mytechnology from  '@/components/technology/technology.vue'
export default {
  components: {
    mycarousel,
    mytechnology
  },
  data(){
    return {
        h51:[
            {
                icon:require('@/assets/h5/h51icon1.png'),
                title:"场景定制<br/>随心所欲"
            },
            {
                icon:require('@/assets/h5/h51icon2.png'),
                title:"场景定制<br/>随心所欲"
            },
            {
                icon:require('@/assets/h5/h51icon3.png'),
                title:"场景定制<br/>随心所欲"
            },
            {
                icon:require('@/assets/h5/h51icon4.png'),
                title:"场景定制<br/>随心所欲"
            },
            {
                icon:require('@/assets/h5/h51icon5.png'),
                title:"场景定制<br/>随心所欲"
            }
        ],
        h54:[
            {
                title:"公众号涨粉解决方案",
                icon:require('@/assets/h5/h54img1.png')
            },
            {
                title:"门店引流解决方案",
                icon:require('@/assets/h5/h54img2.png')
            },
            {
                title:"品牌传播解决方案",
                icon:require('@/assets/h5/h54img3.png')
            },
            {
                title:"电商引流解决方案",
                icon:require('@/assets/h5/h54img4.png')
            },
            {
                title:"展会现场解决方案",
                icon:require('@/assets/h5/h54img5.png')
            },
            {
                title:"增强留存解决方案",
                icon:require('@/assets/h5/h54img6.png')
            },
        ]
    }
  }
}
</script>

<style lang="scss">
    #h5{
        .titleBox{
            .title{
                padding-top: 46px;
                text-align: center;
                font-size: 30px;
                // font-weight: bold;
                color: #333333;
                margin-bottom: 8px;
            }
            .subtitle{
                text-align: center;
                font-size: 16px;
                font-weight: 400;
                color: #666666;
            }
        }
        .h51{
            ul{
                width: 1200px;
                margin:60px auto 87px;
                display: flex;
                justify-content: space-between;
                li{
                    width: 216px;
                    height: 216px;
                    background: #FFFFFF;
                    border-radius: 12px 12px 12px 12px;
                    opacity: 1;
                    border: 1px solid #E4E4E4;
                    font-size: 18px;
                    font-weight: 500;
                    color: #333333;
                    text-align: center;
                    padding-top: 48px;
                    img{
                        width: 62px;
                        margin-bottom: 8px;
                    }
                }
            }
        }
        .h52{
            position: relative;
            .bg{
                width: 100%;
            }
            div{
                padding-left: 736px;
                padding-top: 178px;
                width: 1300px;
                position: absolute;
                top: 0;
                left: 50%;
                transform: translateX(-50%);
                .title{
                    font-size: 28px;
                    font-weight: bold;
                    color: #333333;
                    margin-bottom: 36px;
                }
                ul{
                    span{
                        font-size: 16px;
                        font-weight: 400;
                        color: #666666;
                    }
                    img{
                        width: 12px;
                        margin-right: 8px;
                    }
                    li{
                        margin-bottom: 20px;
                    }
                }
                button{
                    margin-top: 40px;
                    background: #1472FF;
                    border-radius: 100px 100px 100px 100px;
                    width: 152px;
                    font-size: 16px;
                    font-weight: 400;
                    color: #FFFFFF;
                    padding: 10px 0;
                }
            }
        }
        .h53{
            width: 1300px;
            margin:62px auto 0;
            .h53Box{
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0 60px 0 100px;
                .left{
                    .title{
                        font-size: 28px;
                        font-weight: bold;
                        color: #333333;
                        margin-bottom: 36px;
                    }
                    ul{
                        span{
                            font-size: 16px;
                            font-weight: 400;
                            color: #666666;
                        }
                        img{
                            width: 12px;
                            margin-right: 8px;
                        }
                        li{
                            margin-bottom: 20px;
                        }
                    }
                    button{
                        margin-top: 40px;
                        background: #1472FF;
                        border-radius: 100px 100px 100px 100px;
                        width: 152px;
                        font-size: 16px;
                        font-weight: 400;
                        color: #FFFFFF;
                        padding: 10px 0;
                    }
                }
                .right{
                    img{
                        width: 513px;
                    }
                }
            }
        }
        .h54{
            ul{
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                li{
                    width: 380px;
                    position: relative;
                    margin-bottom: 30px;
                    .bg{
                        width: 100%;
                    }
                    div{
                        position: absolute;
                        width: 100%;
                        left: 0;
                        bottom: 0;
                        display: flex;
                        justify-content: space-between;
                        padding: 20px;
                        align-items: center;
                        font-size: 20px;
                        font-weight: 400;
                        color: #FFFFFF;
                        img{
                            width: 20px;
                        }
                    }
                }
            }
        }
    }
</style>